/*
 * @Description: 
 * @Autor: cherry
 * @Date: 2022-05-19 08:34:49
 * @LastEditors: cherry
 * @LastEditTime: 2022-05-20 10:38:30
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace WareHouse {
    /**
    * 获取仓库列表
    */
    export var GetWareHouseList = (query: any): Promise<any> => {
        return Get(`/msls/WareHouse/getWareHouseList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取仓库详情
    */
    export var GetWareHouseDetail = (id: string): Promise<any> => {
        return Get(`/msls/WareHouse/getWareHouseDetail/${id}`, {});
    };
    /**
     * 新增仓库
     */
    export var AddWareHouse = (body: any): Promise<any> => {
        return Post(`/msls/WareHouse/addWareHouse`, body);
    };
    /**
     * 编辑仓库
     */
    export var EditWareHouse = (id: any, body: any): Promise<any> => {
        return Put(`/msls/WareHouse/saveWareHouse/${id}`, body);
    };
    /**
     * 导出
     */
    export var ExportWareHouse = (query: any): Promise<any> => {
        return Download(`/msls/WareHouse/exportWareHouse?${qs.stringify(query)}`, {});
    };
}
